var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebar5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 17.3337H13C13.442 17.3337 13.8659 17.1581 14.1785 16.8455C14.4911 16.5329 14.6667 16.109 14.6667 15.667V4.83366L10.5 0.666992H3C2.55797 0.666992 2.13405 0.842587 1.82149 1.15515C1.50893 1.46771 1.33333 1.89163 1.33333 2.33366V5.66699M9.66667 0.666992V4.00033C9.66667 4.44235 9.84226 4.86628 10.1548 5.17884C10.4674 5.4914 10.8913 5.66699 11.3333 5.66699H14.6667M0.5 11.5003H5.5M3 9.00033V14.0003",
    stroke: "white",
    strokeWidth: 0.888889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar5);
export default __webpack_public_path__ + "static/media/sidebar-5.fed4f61cbceef0cd8da9c6eb8b6c57c5.svg";
export { ForwardRef as ReactComponent };